<template>
  <div id="table-type-options-group">
    <LabelReset
      :modelValue="modelValue"
      @update:modelValue="emit('update:modelValue', $event)"
      :initialValue="initialValue"
    >
      Type
    </LabelReset>
    <RadioInput
      v-for="tableType in table_types"
      :key="tableType.id"
      radioName="table_types_radio"
      :value="tableType.id"
      :modelValue="modelValue"
      @update:modelValue="emit('update:modelValue', $event)"
      :label="tableType.name"
      :uid="`radio-table-type-${tableType.id}`"
    />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { toRefs } from 'vue'

import LabelReset from '@/common/components/molecules/LabelReset.vue'
import RadioInput from '@/common/components/molecules/RadioInput.vue'
import { useSettingStore } from '@/stores/setting'

const emit = defineEmits<{
  // eslint-disable-next-line no-unused-vars
  (e: 'update:modelValue', value: number): void
}>()

const props = withDefaults(
  defineProps<{
    modelValue: number
    initialValue?: number
  }>(),
  {
    initialValue: undefined,
  },
)
const { modelValue } = toRefs(props)

const settingStore = useSettingStore()
const { table_types } = storeToRefs(settingStore)
</script>
